require('./accountsBox.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classnames = require('classnames');
const { connect } = require('react-redux');
const includes = require('lodash/collection/includes');
const some = require('lodash/collection/some');

// @helpers
const { sendTextToClipBoard } = require('commonsUtilities/clipBoardHelper');

// @actions
const transactionActions = require('actions/getAccountsTransactions');
const intervenersActions = require('actions/getAccountInterveners');
const signaturePatternActions = require('actions/signaturePattern');

// @commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

// @components
const AccountsBoxHeader = require('./accountsBoxHeader/accountsBoxHeader');
const AccountsBoxBody = require('./accountsBoxBody/accountsBoxBody');


class AccountsBox extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.copyIbanToClipboard = this.copyIbanToClipboard.bind(this);
        this.handleBoxClick = this.handleBoxClick.bind(this);
    }

    copyIbanToClipboard(iban) {
        sendTextToClipBoard(iban);
    }

    handleBoxClick(evt) {
        const { history, immAccount } = this.props;
        const accountId = immAccount.get('accountId');
        const url = `/myprofile/accounts/${accountId}/movements`;
        const classListWithoutRedirect = [
            'ok-collapsing-toggler'
        ];

        if (!some(evt.target.parentElement.classList, (el) => includes(classListWithoutRedirect, el))) {
            history.push(url);
        }
    }

    handleOnClick(isExpanded) {
        const { index } = this.props;
        this.props.onClick(isExpanded, index);
    }

    render() {
        const {
            expanded,
            flagBasedFeatures,
            immAccount,
            immAccountsTransactions,
            immProfile,
            index,
            requestAccountInterveners,
            requestAccountTransactions,
            validateAndExecuteSagas,
        } = this.props;
        const canceledAccount = immAccount.getIn(['filters', 'canceled']) ? true : false;

        const accountBoxClasses = classnames('accounts-box', {
            'accounts-box--canceled': canceledAccount,
            'accounts-box--is-expanded': expanded,
            'accounts-box--is-clickable': !expanded
        });

        return (
            <div className={accountBoxClasses} onClick={!expanded ? this.handleBoxClick : undefined}>
                <Accordion onClick={this.handleOnClick} isExpanded={expanded}>
                    <AccordionHeader name="AccordionHeader">
                        <AccountsBoxHeader
                            immAccount={immAccount}
                            index={index}
                            copyIbanToClipboard={this.copyIbanToClipboard}
                            expanded={expanded}
                            isBalanceDrawn
                        />
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <AccountsBoxBody
                            flagBasedFeatures={flagBasedFeatures}
                            immAccount={immAccount}
                            immAccountsTransactions={immAccountsTransactions}
                            immProfile={immProfile}
                            index={index}
                            requestAccountInterveners={__CONTACT_CENTER__ ? requestAccountInterveners : undefined}
                            requestAccountTransactions={requestAccountTransactions}
                            validateAndExecuteSagas={validateAndExecuteSagas}
                        />
                    </AccordionBody>
                </Accordion>
            </div>
        );
    }
}

AccountsBox.propTypes = {
    expanded: PropTypes.bool,
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
    immAccount: PropTypes.object,
    immAccountsTransactions: PropTypes.object,
    immProfile: PropTypes.object,
    index: PropTypes.number,
    onClick: PropTypes.func,
    requestAccountInterveners: PropTypes.func,
    requestAccountTransactions: PropTypes.func.isRequired,
    validateAndExecuteSagas: PropTypes.func.isRequired,
};

module.exports.constructor = AccountsBox;
module.exports.AccountsBox = connect((state) => ({
        flagBasedFeatures: state.flagBasedFeatures
    }), {
        requestAccountInterveners: intervenersActions.requestAccountInterveners,
        requestAccountTransactions: transactionActions.requestAccountTransactions,
        validateAndExecuteSagas: signaturePatternActions.validateAndExecuteSagas,
    }
)(withRouter(AccountsBox));
